import { useNavigate } from "react-router-dom";

const PhotoVideo = () => {
    const navigate = useNavigate();

    const goToPhotoSection = (slug) => {
        navigate(`/photographie?section=${slug}`);
    };

    return (
        <div className="container-photovideo min-[320px]:px-4 xl:px-16 min-[320px]mb-8 xl:mb-0 flex justify-between xl:flex-row min-[320px]:flex-col min-[320px]:mt-16 xl:mt-0">
            <div className="video">
                <h2 className="title-video_menu"><a href="/video/publicitaire">VIDEO</a></h2>
                <ul>
                    <li className="text-xl"><a href="/video/corporate" className="link_menu">Corporate</a></li>
                    <li className="text-xl"><a href="/vide/evenementiel" className="link_menu">Evenementiel</a></li>
                </ul>
            </div>
            <div className="photo">
                <h2><a href="/photographie">PHOTO</a></h2>
                <ul>
                    <li className="text-xl"><a onClick={() => goToPhotoSection('corporate')} className="link_menu" style={{cursor:'pointer'}}>Corporate</a></li>
                    <li className="text-xl"><a onClick={() => goToPhotoSection('evenements')} className="link_menu" style={{cursor:'pointer'}}>Evenementiel</a></li>
                </ul>
            </div>
        </div>
    );
};

export default PhotoVideo;